import React from "react";
import { Typography } from "@material-ui/core";
import type { FC } from "react";
import { useStyles } from "./RecentlyCard.styles";

export const RecentlyCardDate: FC = ({ children }) => {
  const classes = useStyles();
  const adapter = {
    body2: classes.date,
  };
  return (
    <Typography component="span" variant="body2" classes={adapter}>
      {children}
    </Typography>
  );
};
